/* FairyGlen low stock urgency: updates the product page callout when the shopper picks another option. */
if (!customElements.get('fg-low-stock')) {
  class FgLowStock extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      } catch (e) {
        return;
      }
      const info = this.closest('.product-info') || document;
      const picker = info.querySelector('variant-picker');
      if (picker) picker.addEventListener('on:variant:change', (evt) => this.onChange(evt));
    }

    onChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      const data = variant ? this.variants.find((v) => v.id === variant.id) : null;
      this.render(data ? data.q : 0, data ? data.c : false);
    }

    render(count, keepsSelling) {
      const hotMax = parseInt(this.dataset.hotMax, 10);
      const warmMax = parseInt(this.dataset.warmMax, 10);
      const hot = this.querySelector('.fg-pdp-stock__hot');
      const warm = this.querySelector('.fg-pdp-stock__warm');
      const level = count > 0 && count <= hotMax ? 'hot' : (count > hotMax && count <= warmMax ? 'warm' : 'none');

      this.hidden = level === 'none';
      hot.hidden = level !== 'hot';
      warm.hidden = level !== 'warm';

      if (level === 'hot') {
        this.querySelector('.js-fg-big').textContent = keepsSelling
          ? `Only ${count} in stock, ready to ship`
          : `Only ${count} left`;
        this.querySelector('.js-fg-bar').style.width = `${count * 8}%`;
        let sub;
        if (keepsSelling) {
          sub = 'Order now and it ships next business day.';
          if (this.dataset.wait) sub += ` After that, new orders usually ship in ${this.dataset.wait}.`;
        } else if (count === 1) {
          sub = 'This is the last one we have. Order soon before it sells out.';
        } else {
          sub = 'Order soon before they sell out.';
        }
        this.querySelector('.js-fg-sub').textContent = sub;
      } else if (level === 'warm') {
        this.querySelector('.js-fg-warm').textContent = keepsSelling
          ? `${count} in stock, ready to ship`
          : `Only ${count} left`;
      }
    }
  }

  customElements.define('fg-low-stock', FgLowStock);
}
